<template>
  <div class="empty-button" @click="onClick">
    <slot></slot>
  </div>
</template>

<script>
export default {
  components: {
  },
  methods: {
    onClick (e) {
      this.$emit('click', e)
    }
  }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

.empty-button
  display flex
  align-items center
  transition all 0.125s
  cursor pointer
  user-select none
  position relative
  box-sizing border-box

  &:hover
    color $color-primary

  &:active
    transform scale(1.0625)
</style>



// WEBPACK FOOTER //
// src/components/v3/buttons/EmptyButton.vue